module.exports = __webpack_public_path__ + "img/Isabel.bb6ec895.jpg";